<template>
  <div>
    <div id="formwaysBuilder"></div>
    <button class="btn btn-success mt-2" type="button" @click="getSchema">
      Save Form
    </button>
  </div>
</template>

<script>
import FormioToFormways from '../utils/translation/FormioToFormways';
import FormwaysToFormio from '../utils/translation/FormwaysToFormio';
import unImplementedComponents from './unImplementedComponents';

export default {
  name: 'fwbuilder',
  props: {
    // formways schema.
    schema: {
      type: Object,
      default: () => ({ components: [] })
    }
  },
  data() {
    return {
      // to store the converted schema from the prop 'schema'
      formioSchema: { components: [] },
      test: { components: [] }
    };
  },
  created() {
    if (this.schema.components.length === 0) {
      this.schema.components.push({
        type: 'button',
        label: 'Submit',
        key: 'submit',
        size: 'md',
        block: false,
        action: 'submit',
        theme: 'primary',
        isNew: true
      });
    }
    this.formioSchema = FormwaysToFormio(this.schema);
    // this.schema.components.forEach(component => {
    //   this.formioComponents.push(FormwaysToformioComponent(component));
    // });
  },
  async mounted() {
    /* global $, Formio */
    this.builder = await new Formio.FormBuilder(
      document.getElementById('formwaysBuilder'),
      {
        display: 'form'
      }
    );

    this.builder.setForm({
      display: 'form',
      components: this.formioSchema.components
    });

    // Hiding unimplemented component menu
    unImplementedComponents.forEach(item => {
      $(`span[data-type='${item}']`).addClass('hidden');
    });
    $('[ref="group-panel-data"]').addClass('hidden');

    /**
     * Available events
     * addComponent : Triggered when new componented is added
     * editComponent: Triggered when edit button for a component is clicked,
     * updateComponent: When a component property is changed in the popup.
     * saveComponent: When save button is clicked in the popup
     * cancelComponent: When cancel button is clicked on the popup
     * removeComponent: When a component is removed from the form
     * change: triggered whenever the schama changes. Param: array of all components in the form
     */
    // this.builder.instance.on('saveComponent', this.addComponent);
  },
  methods: {
    /**
     * Called when a new component is added to the form.
     * Creates a unique key for the newly created field
     */
    // addComponent(schema) {
    //   const eleIndex = this.builder.form.components.findIndex(
    //     element => element.key === schema.key
    //   );
    //   const component = this.builder.form.components[eleIndex];
    //   // if unique id is added to the key, the key will be of the format "textField__eyy3nme"
    //   const isIdGenerated = /^[a-zA-z0-9]*__[a-zA-Z0-9]+$/.test(component.key);
    //   if (!isIdGenerated) {
    //     component.key = `${component.key}__${getRandomString(7)}`;
    //     component.isNew = true;
    //   }
    // },
    getSchema() {
      this.$emit(
        'save',
        FormioToFormways(this.builder.instance.schema.components, this.schema)
      );
    }
  }
};
</script>

<style>
.hidden {
  display: none;
}
</style>
